import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_icon = _resolveComponent("my-icon")!

  return (_ctx.docCount > 0)
    ? (_openBlock(), _createBlock(_component_my_icon, {
        key: 0,
        icon: _ctx.icon,
        size: _ctx.size,
        color: _ctx.color,
        title: _ctx.docInfoText
      }, null, 8, ["icon", "size", "color", "title"]))
    : (_ctx.fillSpace)
      ? (_openBlock(), _createBlock(_component_my_icon, {
          key: 1,
          icon: "empty",
          size: _ctx.size
        }, null, 8, ["size"]))
      : _createCommentVNode("", true)
}